// extracted by mini-css-extract-plugin
export var root = "social-module--root---GNmk";